import { PRINTER_TYPE_QR } from "./types";

export const toBytesU8  = function(str) {
    return new TextEncoder().encode(str);
}

export const toBytes = function(data) {
    var arr = [];
    for (var i = 0; i < data.length; i++) {
        arr.push(data[i].charCodeAt(0));
    }
    return arr;
}

export const COMPLEX_ROW_SEPARATOR = "$%rs%$";
export const BULK_TRANSFER_SIZE = 16 * 64; //64 bytes * 16 bits per byte
export const MAX_NUMBER_TRANSFERS = 3;
export const DOUBLE_DENSITY_24_BIT = 33;
export const PRINT_HEAD_BITS = 8;

// setting commands for printing, array for data, and calculations
export const LINE_SPACING_DEFAULT = [0x01B, 0x32];
export const LINE_SPACING_IMAGE = [0x01B, 0x33, 8];

export const ALIGN_LEFT = [0x01B, 0x061, 0];
export const ALIGN_CENTER = [0x01B, 0x061, 1];
export const ALIGN_RIGHT = [0x01B, 0x061, 2];
export const END_PRINT = [0x01B, 0x064, 2];

export const LINE_FEED = [0x00A];
export const FEED_PAPER = [0x0C];
export const BUZZ = [0x07];
export const DRAW_LINE_MIDDLE = toBytes("________________________________________________");
export const DRAW_LINE_SMALL = toBytes("________________________________");
export const ADD_BLANK_LINE = toBytes("\n");
export const HORIZONTAL_TAB = [0x009];
export const BOLD_FONT = [0x1B, 0x21, 0x008];
export const ITALIC_FONT = [0x1B, 0x21, 0x040];
export const UNDERLINE_FONT = [0x1B, 0x21, 0x080];
export const DISABLE_FONT_DECORATION = [0x1B, 0x21, 0x000];
export const CUT_PAPER_FULL = [0x01D, 0x056, 1];
export const CUT_PAPER_PARTIAL = [0x01D, 0x056, 0];
export const MARGIN_NONE = [0x01D, 0x04C, 0, 0];

export const ESC_BIT_IMAGE = [0x1b, 0x2a];

export const PRINT_LANG_ESC = "esc";
export const PRINT_LANG_ZPL = "zpl";
export const PRINT_LANG_TSPL = "tspl";

export const DOTS_DENSITY = 24;

export const LUMINANCE = {RED: 0.299, GREEN: 0.587, BLUE: 0.114};

export const getEndpoint = function(endpoints, direction) {
    //return default endpoint as 2

    // console.log("supported devices 5", endpoints, direction);

    if(!endpoints) return undefined;

    for (var e = 0; e < endpoints.length; e++) {
        if(endpoints[e].direction === direction) return endpoints[e];
    }

    return undefined;
}

export const getEndpointNumber = function(endpoints, direction) {
    //return default endpoint as 2

    // console.log("supported devices 5", endpoints, direction);

    if(!endpoints) return 0;

    for (var e = 0; e < endpoints.length; e++) {
        if(endpoints[e].direction === direction) return endpoints[e].endpointNumber;
    }

    return 0;
}

export const isChrome = () => {
    var result = false;

    result = navigator.userAgent.includes("Chrome") && navigator.vendor.includes("Google Inc");

    return result;
}

const calculateLuminance = function(pixel) {
    return LUMINANCE.RED * pixel[0] 
            + LUMINANCE.GREEN * pixel[1] 
            + LUMINANCE.BLUE * pixel[2];
}

const calculateSlice = function(x, y, image) {
    const threshold = 127;
    let slice = 0;
    let luminance;

    for (let bit = 0; bit < PRINT_HEAD_BITS; bit++) {
        if ((y + bit) >= image.height)
            continue;

        luminance = calculateLuminance(image.data[y + bit][x])

        slice |= (luminance < threshold ? 1 : 0) << 7 - bit
    }

    return slice;
}

const collectStripe = function(x, y, image) {
    let slices = [];
    let z = y + DOTS_DENSITY;

    let i = 0
    while (y < z && i < 3){
      slices.push(calculateSlice(x, y, image));

      y += PRINT_HEAD_BITS
    }

    return slices;
}

const manipulateImage = function (data, image) {
    // console.log("image size", image.width, image.height);
    const imageWidth = image.width;

    for (let y = 0; y < image.height; y += DOTS_DENSITY){
        data.push(...ESC_BIT_IMAGE, DOUBLE_DENSITY_24_BIT, (0x00ff & imageWidth), (0xff00 & imageWidth) >> 8);

        for (let x = 0; x < imageWidth; x++) {
            data.push(...collectStripe(x, y, image));
        }

        data.push(LINE_FEED);
    }

    // console.log("transformed data", data);
}

const prepareStringData = function (data, deviceLanguage) {
    // console.log("device prepare string", data);

    var transformString = data;
    var anything = LINE_SPACING_DEFAULT;
    
    let charIndex = 0;

    while(charIndex < transformString.length){
        //check if have special char at the current char
        if(transformString.indexOf("\n", charIndex) - charIndex === 0){
            anything.push(...LINE_FEED);
            charIndex++;
        }
        else if(transformString.indexOf("%%fb%%", charIndex) - charIndex === 0){
            anything.push(...BOLD_FONT);
            charIndex = charIndex + "%%fb%%".length;
        }
        else if(transformString.indexOf("%%fi%%", charIndex) - charIndex === 0){
            anything.push(...ITALIC_FONT);
            charIndex = charIndex + "%%fi%%".length;
        }
        else if(transformString.indexOf("%%fu%%", charIndex) - charIndex === 0){
            anything.push(...UNDERLINE_FONT);
            charIndex = charIndex + "%%fu%%".length;
        }
        else if(transformString.indexOf("%%dfd%%", charIndex) - charIndex === 0){
            anything.push(...DISABLE_FONT_DECORATION);
            charIndex = charIndex + "%%dfd%%".length;
        }
        else if(transformString.indexOf("%%al%%", charIndex) - charIndex === 0){
            anything.push(...ALIGN_LEFT);
            charIndex = charIndex + "%%al%%".length;
        }
        else if(transformString.indexOf("%%ar%%", charIndex) - charIndex === 0){
            anything.push(...ALIGN_RIGHT);
            charIndex = charIndex + "%%ar%%".length;
        }
        else if(transformString.indexOf("%%ac%%", charIndex) - charIndex === 0){
            anything.push(...ALIGN_CENTER);
            charIndex = charIndex + "%%ac%%".length;
        }
        else if(transformString.indexOf("%%dl%%", charIndex) - charIndex === 0){
            anything.push(...DRAW_LINE_SMALL);
            charIndex = charIndex + "%%dl%%".length;
        }
        else if(transformString.indexOf("%%t%%", charIndex) - charIndex === 0){
            anything.push(...HORIZONTAL_TAB);
            charIndex = charIndex + "%%t%%".length;
        }
        else if(charIndex < transformString.length){
            anything.push(...toBytes(transformString.charAt(charIndex)));
            charIndex++;
        }
    }

    anything.push(...LINE_FEED);

    return anything;
}

const prepareBarcodeData = function (data, deviceLanguage) {
    // console.log("device prepare string", data);

    if(deviceLanguage === PRINT_LANG_ZPL){
        let cmds = [];
        let dataS = String(data.data);
        //break the data into multiple records
        let dataArr = dataS.trim().split(COMPLEX_ROW_SEPARATOR)
        
        //convert each record to bytes and then uint8 array
        for (let i = 0; i < dataArr.length; i++) {
            if (dataArr[i].trim() !== ""){
                let arrayLike = toBytes(dataArr[i].trim());
                let uintArr = new Uint8Array( arrayLike );
                cmds[i] = uintArr;
            }
        }

        //and then push it to cmds
        
        // let arrayLike = toBytes(cmds.join('\r\n'));
    
        return cmds;
    }
    else if(deviceLanguage === PRINT_LANG_TSPL){
        let dataS = String(data.data);
        let dataArr = dataS.trim().split(COMPLEX_ROW_SEPARATOR);

        // Join all non-empty commands with CRLF
        let joinedCmds = dataArr
            .map(cmd => cmd.trim())
            .filter(cmd => cmd !== "")
            .join('\r\n');

        console.log("TSPL string", joinedCmds);

        let arrayLike = toBytesU8(joinedCmds);
        let uintArr = new Uint8Array(arrayLike);

        // Return a single Uint8Array for TSPL
        return [uintArr];
    }
}

const prepareImageData = function(data, deviceLanguage) {
    let transformedImage = [];

    if(deviceLanguage === PRINT_LANG_ESC){
        transformedImage.push(...LINE_SPACING_IMAGE);
        // transformedImage.push(...LINE_SPACING_DEFAULT);

        manipulateImage(transformedImage, data);
        
        transformedImage.push(...LINE_SPACING_DEFAULT);
        transformedImage.push(...LINE_FEED);
        transformedImage.push(...LINE_FEED);
    }
    
    return transformedImage;
}

export const prepareData = function(printData, deviceLanguage) {
    var data = [];

    if (printData.printType === PRINTER_TYPE_QR){
        return prepareBarcodeData(printData, deviceLanguage);
    }
    else if(printData.isImage){
        data = prepareImageData(printData.data, deviceLanguage);
    }
    else{
        data = prepareStringData("test data that is not to be printed, printer issue debugging", deviceLanguage);
    }

    data.push(...END_PRINT);
    data.push(...CUT_PAPER_PARTIAL);
    data.push(...FEED_PAPER);

    console.log("print data", data);
    
    let dataArray = new Uint8Array(data);

    return dataArray;
}
